import es from 'react-phone-input-2/lang/es.json';
import de from 'react-phone-input-2/lang/de.json';
import fr from 'react-phone-input-2/lang/fr.json';
import it from 'react-phone-input-2/lang/it.json';
import jp from 'react-phone-input-2/lang/jp.json';
import pt from 'react-phone-input-2/lang/pt.json';

const supportedPhoneLanguages = [
  {
    id: 'es',
    translations: es,
  },
  {
    id: 'de',
    translations: de,
  },
  {
    id: 'fr',
    translations: fr,
  },
  {
    id: 'it',
    translations: it,
  },
  {
    id: 'jp',
    translations: jp,
  },
  {
    id: 'pt',
    translations: pt,
  },
];

export default function getPhoneInputTranslations(lang) {
  const selectedLanguage = supportedPhoneLanguages.find(language => language.id === lang);
  if (selectedLanguage) {
    return selectedLanguage.translations;
  } else {
    return null;
  }
}
